import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

import type { OptionData, OptionUiSetting } from '../../../../type/common.type';

interface Props {
  option: OptionData;
  ui_setting?: OptionUiSetting;
}

export const PriceStock = ({ option, ui_setting }: Props) => {
  const display_restock_notification_selection = ui_setting?.display_style === 'restock_notification_selection';
  const is_sold_out = (!display_restock_notification_selection && option.stock_status?.is_sold_out) || false;
  const isRestricted = option.isRestricted ?? false;
  const isDisabled = is_sold_out || isRestricted;

  if (!option.display_price) {
    return null;
  }

  return (
    <Container>
      {!!option.display_price && (
        <Text variant='Body_15_Medium' v3Color={isDisabled ? 'gray200' : 'gray500'}>
          {numberWithCommas(option.display_price) ?? 0}원
        </Text>
      )}
      {!!option.stock_status?.remain_stock_count && (
        <Text variant='Caption_12_Medium' color='red200' style={{ marginTop: 4 }}>
          {option.stock_status.remain_stock_count}개 남음
        </Text>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 91px;
  margin-left: 10px;
`;
